import progressMessages from './progressMessages'

/**
 * Parse and translate progress message from Server-Sent Events
 * @param {string} data - Raw data from SSE event
 * @param {function} formatMessage - react-intl formatMessage function
 * @returns {string} Translated message or fallback text
 */
export const parseProgressMessage = (data, formatMessage) => {
  try {
    // Try to parse as JSON (new format with message key)
    const parsed = JSON.parse(data)

    if (parsed.MessageKey && progressMessages[toCamelCase(parsed.MessageKey)]) {
      const messageKey = toCamelCase(parsed.MessageKey)
      const params = parsed.Params || {}

      // Convert C# PascalCase params to camelCase for JS
      const jsParams = Object.keys(params).reduce((acc, key) => {
        acc[key.charAt(0).toLowerCase() + key.slice(1)] = params[key]
        return acc
      }, {})

      return formatMessage(progressMessages[messageKey], jsParams)
    }

    // Fallback to provided text if translation not found
    if (parsed.FallbackText) {
      return parsed.FallbackText
    }

    // If it's a plain string in JSON
    return data
  } catch (e) {
    // If JSON parsing fails, treat as plain text (old format)
    return data
  }
}

/**
 * Convert "progress.loadingData" to "loadingData"
 */
const toCamelCase = (str) => {
  if (!str) return str
  const parts = str.split('.')
  return parts[parts.length - 1]
}
